import { useFormContext } from "react-hook-form";
import { Input, InputProps } from "../ui/input";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "../ui/form";

export default function TextField({ label, name, helpText, ...props }: { label: string, name: string, helpText?: string } & Partial<InputProps>) {
    const form = useFormContext()
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel htmlFor={name}>{label}</FormLabel>
                    <FormControl>
                        <Input id={name} {...field} {...props} />
                    </FormControl>
                    {helpText && <p className='text-sm text-muted-foreground'>{helpText}</p>}
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}